import { SITE } from '.';

export const VIDU_SKILL_GITHUB_URL = 'https://github.com/shengshu-ai/vidu-skills';

// claw 规则url
export const CLAW_RULES_URL =
  SITE === 'china'
    ? 'https://shengshu.feishu.cn/wiki/HDVlw3TIEi2GxFkJIfNcYKiNnWh'
    : 'https://www.notion.so/35124005a3e480d7986cdcbd3e8a68c6?showMoveTo=true&saveParent=true';

const CN_APPLY_CLAW_URL = 'https://shengshu.feishu.cn/share/base/form/shrcntNhk4AILpjkfxVm3amG0tc';
const GLOBAL_APPLY_CLAW_URL = 'https://forms.gle/8NAviidkeu76cFQM6';
export const APPLY_CLAW_URL = SITE === 'china' ? CN_APPLY_CLAW_URL : GLOBAL_APPLY_CLAW_URL;

// Claw 功能介绍页（外部站点）
export const CLAW_USAGE_GUIDE_URL =
  SITE === 'china'
    ? 'https://shengshu.feishu.cn/docx/AjNmdmjPGoobbCxZxQLckkZInuf'
    : 'https://viduclaw-guide.vercel.app/';
